import api from "../index";

export const GetAllCountryApi = () => api.get('dropdown/getcountry');